import { render, staticRenderFns } from "./Judge.vue?vue&type=template&id=348955b0&scoped=true&"
import script from "./Judge.vue?vue&type=script&lang=js&"
export * from "./Judge.vue?vue&type=script&lang=js&"
import style0 from "./Judge.vue?vue&type=style&index=0&id=348955b0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348955b0",
  null
  
)

export default component.exports